export { MIN_PASSWORD_LENGTH } from './chunk-SCUIZY5L.js';
import { magicLinkClient, inferAdditionalFields } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

function createAppAuthClient(baseURL) {
  return createAuthClient({
    baseURL,
    plugins: [magicLinkClient(), inferAdditionalFields()]
  });
}

export { createAppAuthClient };
//# sourceMappingURL=client.js.map
//# sourceMappingURL=client.js.map